import { render, staticRenderFns } from "./u-header-basic.vue?vue&type=template&id=29dc2c78&scoped=true&"
import script from "./u-header-basic.vue?vue&type=script&lang=js&"
export * from "./u-header-basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc2c78",
  null
  
)

export default component.exports